import React, { useState, useEffect, useContext } from 'react';
import Context from '../../../utils/context';
import { Switch, useParams, useRouteMatch, Route, useHistory, Link } from 'react-router-dom';
import { getConversationSurvey, updateConversationSurvey } from '../../../api/conversation_surveys';
import LoadingScreen from '../../loading_screen';
import Generic from './generic';
import Xcopri from './xcopri';
import Ossio from './ossio';
import Medtronic from './medtronic';
import Reactiv8 from './reactiv8';
import styles from '../index.module.css';

export default function PostConversationQuestionnaire() {
  const context = useContext(Context);
  const [conversationSurvey, setConversationSurvey] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const { conversationSurveyId } = useParams();

  let history = useHistory();
  let { path } = useRouteMatch();
  path = path.replace(':conversationSurveyId', conversationSurveyId);

  useEffect(() => {
    new Promise((resolve) => {
      getConversationSurvey(conversationSurveyId, (data) => {
        setConversationSurvey(data);
        resolve();
      });
    }).finally(() => {
      setIsLoading(false);
    });
  }, [conversationSurveyId, history, path]);

  const update = (params) => {
    updateConversationSurvey(conversationSurveyId, params, (data) => setConversationSurvey(data));
  };

  const answeredFinalQuestion = (params) => {
    update({ ...params, completed: true });
  };

  const renderAllQuestionnaires = () => {
    if (!conversationSurvey) {
      return (
        <div>
          <p className={styles.thank_you}>Thank you!</p>
          <p className={styles.thank_you_p}>
            We're sorry, but we couldn't find a survey for this conversation. Please try again later.
          </p>
          <Link to={context.auth.isLoggedIn() ? '/member/conversations' : `/member/login`}>
            <button className={`${styles.thank_you_button}`}>Home</button>
          </Link>
        </div>
      );
    }

    if (conversationSurvey.completed) {
      return (
        <div>
          <p className={styles.thank_you}>Thank you!</p>
          <p className={styles.thank_you_p}>
            Your feedback is invaluable to us. With it, we can continue to improve the platform and experience for
            patients everywhere.
          </p>
          <Link to={context.auth.isLoggedIn() ? '/member/conversations' : `/member/login`}>
            <button className={`${styles.thank_you_button}`}>Home</button>
          </Link>
        </div>
      );
    }

    const SURVEY_COMPONENTS = {
      xcopri: Xcopri,
      ossiofiber: Ossio,
      'dr-moises-jacobs': Medtronic,
      'dr-amir-aryaie': Medtronic,
      'dr-broderick': Medtronic,
      reactiv8: Reactiv8,
      'reactiv8-australia': Reactiv8,
      default: Generic,
    };

    const SurveyComponent = SURVEY_COMPONENTS[conversationSurvey.surgeon_slug] || SURVEY_COMPONENTS.default;

    const commonProps = {
      path: `${path}`,
      update,
      answeredFinalQuestion,
      history,
      conversationSurvey,
    };

    return (
      <Switch>
        <Route path={`${path}`}>
          <SurveyComponent {...commonProps} />
        </Route>
      </Switch>
    );
  };

  return (
    <div className={styles.questionnaire_ottr} style={{ backgroundColor: '#f5f7f9', maxWidth: '100%' }}>
      <div id='questionnaire' className='container h-100'>
        <div className='row justify-content-center h-100'>
          <div className='col h-100'>
            <div className={`row ${styles.introQuestion} h-100`}>
              <div className='col-sm-2'></div>
              <div className='col-sm-8'>{isLoading ? <LoadingScreen /> : renderAllQuestionnaires()}</div>
              <div className='col-sm-2'></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
